export const NAVIGATION_PANEL_MIN_SCROLL_TOP = 100;
